import { TIMELINE_DIAGRAM_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ICardsProps } from "../../Cards"
import TimeLineDiagramSinusoid from "./TimeLineDiagramSinusoid"
import TimeLineDiagramDiagonal from "./TimeLineDiagramDiagonal"
import TimeLineDiagramGallery from "./TimelineDiagonalGallery"
import TimelineDiagramConcertino from "./TimelineDiagramConcertino"
import { HasId, ID } from "src/libs/interfaces/layouts"


/* Protopia Ecosystem component */
export interface ITimelineDiagramProps extends Omit<ICardsProps, "cards"> { 
    cards: HasId[]
    timelineId:ID
} 
const TimelineDiagram = ({...props}: ITimelineDiagramProps): JSX.Element => {
    
    switch(props.data.dots?.type) {
        case TIMELINE_DIAGRAM_TYPE.GALLERY:
            return <TimeLineDiagramGallery {...props} />
        case TIMELINE_DIAGRAM_TYPE.CONCERTINO:
            return <TimelineDiagramConcertino {...props} />
        case TIMELINE_DIAGRAM_TYPE.BREAK_LINE:
        case TIMELINE_DIAGRAM_TYPE.DIAGONAL:
            return <TimeLineDiagramDiagonal {...props} />
        case TIMELINE_DIAGRAM_TYPE.SINUSOID:
        default:
            return <TimeLineDiagramSinusoid {...props} />
    }
}
export default TimelineDiagram